import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './StoresList.module.sass';
import NavigationBlackIcon from '../../../../images/icons/navigation-black.svg';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import { shopsActions } from '../../actions';
import { activeStoreIdSelector } from '../../selectors/shops';

class Store extends Component {
  componentDidMount() {
    window.addEventListener('info_window_closed', this.onInfoWindowClose);
  }

  componentWillUnmount() {
    window.removeEventListener('info_window_closed', this.onInfoWindowClose);
  }

  onInfoWindowClose = (event) => {
    const { shop, setActiveStoreId } = this.props;
    const incomingShopId = event.detail;
    if (shop.id === incomingShopId) {
      setActiveStoreId(null);
    }
  };

  onDirectionClick = () => {
    const { shop } = this.props;
    window.broadCastDirectionsClick(shop.id);
  };

  render() {
    const { shop, number, activeStoreId } = this.props;
    return (
      <div className={`${styles.store} ${activeStoreId === shop.id ? styles.active : ''}`} key={shop.id} id={shop.id}>
        <div className={styles.number}>
          { (number + 1) }
          .
        </div>
        <div className={styles.info}>
          <div className={styles.name}>
            { shop.name }
          </div>
          <div className={styles.address}>
            { shop.full_address }
          </div>
          <div className={styles['working-hours']} dangerouslySetInnerHTML={{ __html: shop.working_hours }} />
        </div>
        <ClickableDiv
          className={styles.direction}
          onClick={this.onDirectionClick}
        >
          <span className={styles.miles}>
            { `${shop.distance.toFixed(1)} mi` }
          </span>
          <img src={NavigationBlackIcon} alt="" />
        </ClickableDiv>
      </div>
    );
  }
}

Store.propTypes = {
  number: PropTypes.number.isRequired,
  setActiveStoreId: PropTypes.func.isRequired,
  activeStoreId: PropTypes.number,
  shop: PropTypes.shape({
    name: PropTypes.string.isRequired,
    full_address: PropTypes.string.isRequired,
    distance: PropTypes.number.isRequired,
    working_hours: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setActiveStoreId: (activeStoreId) => {
    dispatch(shopsActions.setActiveStoreId(activeStoreId));
  },
});

const mapStateToProps = (state) => ({
  activeStoreId: activeStoreIdSelector(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Store);
